/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { ContentBlock } from './ContentBlock';
import { EmailChangeFormSection } from './EmailChangeFormSection';
import { PaymentSection } from './PaymentSection';
import { ProfileFormSection } from './ProfileFormSection';

const EditUserBlock = () => (
  <ContentBlock>
    <ProfileFormSection />
    <EmailChangeFormSection $withSplitter />
    <PaymentSection $withSplitter />
  </ContentBlock>
);

export { EditUserBlock };
